import { OrderList } from './order-list.model';

export class OrderListData {
  TotalCount: number;
  Orders: OrderList[];
 }
